import {RefundOrder} from 'app/features/orders/models/OrderRefundState'
import {reject, isNaN, find} from 'lodash'
import {actionType, mapToOrderEditDiscountModel, mapToViewOrderModel} from '../helper'

const calculateTotalPrice = (order: RefundOrder) => {
  let totalPrice = parseFloat(order.subtotalPrice)

  if (order.totalTax) {
    totalPrice += parseFloat(order.totalTax)
  }

  if (order.salesTax) {
    totalPrice += parseFloat(order.salesTax)
  }

  if (order.totalDiscounts) {
    totalPrice -= parseFloat(order.totalDiscounts)
  }

  if (order.wineClubDiscounts) {
    totalPrice -= parseFloat(order.wineClubDiscounts)
  }

  if (order.shippingRefundPrice) {
    totalPrice += parseFloat(order.shippingRefundPrice)
  }
  if (order.tipAmount) {
    totalPrice += parseFloat(order.tipAmount)
  }
  return totalPrice
}

export const getRefundOrder = () => async (dispatch: any, getState: any) => {
  const state: any = getState()
  const {deletedItems, newItems, viewOrder, refund, isRestock, ...rest} = state.orders.orderRefund
  return {deletedItems, newItems, viewOrder, refund, isRestock, ...rest}
}

export const setOrderSubtotal = (state: any, action: any) => {
  state.refund.subtotalPrice = action.payload
  state.refund.totalPrice = calculateTotalPrice(state.refund)
}

export const setOrderSalesTax = (state: any, action: any) => {
  state.refund.totalTax = action.payload
  state.refund.totalPrice = calculateTotalPrice(state.refund)
}

export const setRefundNote = (state: any, action: any) => {
  state.refund = {
    ...state.refund,
    note: action.payload,
  }
}

export const setShippingRefundPrice = (state: any, action: any) => {
  state.refund = {
    ...state.refund,
    shippingRefundPrice: action.payload,
  }
  state.isDirty = true
  setTotalTax(state, {payload: action.payload})
  state.refund.totalPrice = calculateTotalPrice(state.refund)
}

export const setOrderRefundPrice = (state: any, action: any) => {
  state.refund = {
    ...state.refund,
    orderRefundPrice: action.payload,
  }
  state.isDirty = true
  state.refund.totalPrice = calculateTotalPrice(state.refund)
}

export const setIsValidatingDiscount = (state: any, action: any) => {
  state.isValidatingDiscount = action.payload
}

export const setRefundDiscounts = (state: any, {payload}: any) => {
  const {discounts, removeDiscounts}: any = payload
  let totalDiscounts = 0,
    wineClubDiscounts = 0,
    wineClubDiscountCodeId = null,
    discountCodeId = null
  let removeDiscountIds: any[] = []

  removeDiscounts.forEach((discount: any) => {
    removeDiscountIds.push(discount.id)
  })

  const appliedDiscounts = discounts.map((discount: any) => {
    if (discount && discount.isWineClub) {
      wineClubDiscountCodeId = discount.discountCodeId
      const originalAmount = parseFloat(discount.amount)
      let amount = parseFloat(discount.amount)
      const discountAmount = parseFloat(discount.discountAmount || 0)
      amount -= discountAmount
      wineClubDiscounts += amount
      if (amount <= 0) {
        removeDiscountIds.push(discount.id)
      }

      if (wineClubDiscounts > 0) {
        return {...discount, amount: originalAmount - wineClubDiscounts}
      }

      return {...discount, amount: originalAmount}
    }
    if (discount && discount.isPromoCode) {
      discountCodeId = discount.discountCodeId
      const originalAmount = parseFloat(discount.amount)
      let amount = parseFloat(discount.amount)
      const discountAmount = parseFloat(discount.discountAmount || 0)
      amount -= discountAmount
      totalDiscounts += amount
      if (amount <= 0) {
        removeDiscountIds.push(discount.id)
      }

      if (totalDiscounts > 0) {
        return {...discount, amount: originalAmount - totalDiscounts}
      }

      return {...discount, amount: originalAmount}
    }
    return discount
  })

  state.refund.discounts = appliedDiscounts
  state.refund.removeDiscountIds = removeDiscountIds
  state.refund.wineClubDiscounts = wineClubDiscounts
  state.refund.wineClubDiscountCodeId = wineClubDiscountCodeId
  state.refund.discountCodeId = discountCodeId
  state.refund.totalDiscounts = totalDiscounts
  state.refund.totalPrice = calculateTotalPrice(state.refund)
}

export const resetRefundDiscount = (state: any) => {
  state.refund.totalDiscounts = 0
  state.refund.wineClubDiscounts = 0
  state.refund.totalPrice = calculateTotalPrice(state.refund)
}

export const setDeleteItems = (state: any, payload: any) => {
  switch (payload.type) {
    case actionType.add: {
      state.deletedItems.push(payload.data)
      state.isDirty = true
      state.refund.orderRefundPrice = 0
      return {...state}
    }
    case actionType.remove: {
      state.deletedItems = reject(state.deletedItems, {variantId: payload.data})
      state.isDirty = true
      state.refund.orderRefundPrice = 0
      return {...state}
    }
    case actionType.update: {
      const index = state.deletedItems.findIndex(
        ({variantId}: any) => variantId === payload.data.variantId
      )
      state.deletedItems[index] = payload.data
      state.isDirty = true
      return {...state}
    }
    default: {
      state.deletedItems = [...state.deletedItems, ...payload]
      return {...state}
    }
  }
}

export const setUpdateDeleteItems = (state: any, {payload}: any) => {
  const items = state.deletedItems.map((deletedItem: any) => {
    const item = find(payload, {variantId: deletedItem.variantId})
    if (item) {
      return {...deletedItem, id: item.id}
    }
    return deletedItem
  })

  if (payload && items.length > 0) {
    state.deletedItems = items
  }
}

export const setRefundOrder = (state: any, action: any) => {
  const {order, ...rest} = action.payload
  const {shippingPrice, orderDeliveryMethod} = mapToViewOrderModel(order)
  state.refund = {
    ...rest,
    shippingPrice: 0,
    subtotalPrice: 0,
    totalPrice: 0,
    totalTax: 0,
    totalDiscounts: 0,
    wineClubDiscounts: 0,
    maxShippingRefundFee: shippingPrice,
    orderDeliveryMethod,
    selectedItemDiscounts: {wineClubDiscounts: 0, totalDiscounts: 0},
  }
  state.viewOrder = mapToViewOrderModel(order)
  state.discounts = mapToOrderEditDiscountModel(rest.discounts.nodes)
}

export const setOrderNote = (state: any, action: any) => {
  state.refund = {
    ...state.refund,
    note: action.payload,
  }
}

export const setTotalTax = (state: any, {payload}: any) => {
  if (isNaN(payload)) {
    payload = 0
  }
  const freightSalesTax = parseFloat(state.viewOrder.freightSalesTax)
  let tax = 0

  if (freightSalesTax > 0 && payload > 0) {
    const taxPerDollar = freightSalesTax / parseFloat(state.viewOrder.shippingPrice)
    tax += taxPerDollar * parseFloat(payload)
  }
  state.refund.freightSalesTax = freightSalesTax - tax
  state.refund.salesTax = tax
  state.refund.totalPrice = calculateTotalPrice(state.refund)
}

export const setUpdateRefundDiscounts = (state: any, {payload}: any) => {
  state.discounts = mapToOrderEditDiscountModel(payload)
}

const setDiscountIfIsRefundAll = (state: any) => {
  if (state.isRefundAll) {
    state.refund.wineClubDiscounts = state.viewOrder.wineClubDiscounts
    state.refund.totalDiscounts = state.viewOrder.totalDiscounts
  }
}
